import moment from 'moment-timezone';
import store from '@/store'; // adjust the path as needed

class Services {
  constructor() {
  }

  // RETURN A NICE DATE STRING
  static getCurrentDate(date) {
    let m;
    const timezone = store.state.timezone || 'Israel'; // fallback if not set
    console.log("Timezone: ", timezone);

    if (date) {
      m = moment.tz(date, timezone);
    } else {
      m = moment.tz(timezone);
    }

    const formattedDate = m.format('DD/MM/YYYY');
    const formattedTime = m.format('HH:mm:ss');

    return `${formattedDate},${formattedTime}`;
  }

   // RETURN ISO STYLE FORMAT (YYYY-MM-DDTHH:mm:ss)
   static getFormatDate(date) {
    const timezone = store.state.timezone || 'Israel'; // fallback if not set
    const m = date ? moment.tz(date, timezone) : moment.tz(timezone);
    return m.format('YYYY-MM-DDTHH:mm:ss');
  }

   // RETURN SIMPLE FORMAT (YYYY-MM-DD HH:mm)
   static getFormatDate2(date) {
    const timezone = store.state.timezone || 'Israel'; // fallback if not set
    const m = date ? moment.tz(date, timezone) : moment.tz(timezone);
    return m.format('YYYY-MM-DD HH:mm');
  }


  static getPercentage(listenedDuration, fullFileDuration) {
    console.log("listenedDuration: ", listenedDuration);
    console.log("fullFileDuration: ", fullFileDuration);
    
    if (fullFileDuration === 0) {
      return 0; // Avoid division by zero
    }
    const percentage = (listenedDuration / fullFileDuration) * 100;
    console.log("percentage: ", Math.ceil(percentage));
    
    return Math.ceil(percentage); // Round up to the nearest whole number
  }




 // RETURN A DATE OBJECT FOR SORTING
 static getoBJDate(dateString) {
  const timezone = store.state.timezone || 'Israel'; // fallback if not set
  let [datePart, timePart] = dateString.split(",");
  let [day, month, year] = datePart.split("/");

  const dateInMoment = moment.tz(`${year}-${month}-${day} ${timePart}`, 'YYYY-MM-DD HH:mm:ss', timezone);
  return dateInMoment.toDate(); // native Date object
}

}

export default Services;

